export default __webpack_public_path__ + "static/media/switch2.5282085a.svg";